import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Container,
  Avatar,
  TextField,
  Button,
  Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from "react-router-dom";

function VideosPopularPage() {
    const [videos, setVideos] = useState([]);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const res = await axios.get('/videos/popularVideos');
                setVideos(res.data);
            } catch (err) {
                console.error("Fetch failed", err);
            }
        };
        fetchVideos();
    }, []);

    const toggleVote = async (postId) => {
        try {
            const res = await axios.post(`/videos/${postId}/upvote`);
            setVideos(prev =>
                prev.map(p =>
                    p._id === postId
                    ? { ...p, upvotes: res.data.upvotes, voted: res.data.voted }
                    : p
                )
            );
        } catch (err) {
            console.error("Vote error", err);
        }
    };

    const handleAddComment = async (postId, commentText) => {
        if (!commentText.trim()) return;

        try {
            const res = await axios.post(`/videos/${postId}/comment`, { text: commentText });
            setVideos(prev =>
            prev.map(p =>
                p._id === postId
                ? { ...p, comments: res.data, newComment: "" }
                : p
            )
            );
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };

    const joinVideoCall = async (postId) => {
        try {
            const res = await axios.post(`/video/${postId}/video-room`);
            const roomUrl = res.data.url;
            window.open(roomUrl, "_blank");
        } catch (err) {
            console.error("Failed to join video call", err);
            alert("Could not join video call.");
        }
    };

    const [open, setOpen] = useState(false);
    const [videoFile, setVideoFile] = useState(null);
    const [description, setDescription] = useState("");
    const [title, setTitle] = useState("");

    const [thumbnailFile, setThumbnailFile] = useState(null);

    const [videoFileName, setVideoFileName] = useState("");
    const [thumbnailFileName, setThumbnailFileName] = useState("");

    const handleUpload = async () => {
        if (!videoFile) return;

        const MAX_SIZE = 200 * 1024 * 1024;
        if (videoFile.size > MAX_SIZE) {
            alert("Video is too large. Max size is 200MB.");
            return;
        }

        const formData = new FormData();
        formData.append('video', videoFile);
        if (thumbnailFile) {
            formData.append("thumbnail", thumbnailFile);
        }
        formData.append('description', description);
        formData.append('title', title);

        try {
            const res = await axios.post('/videos/upload', formData);
            console.log("Upload success:", res.data);
            setOpen(false); // close dialog
        } catch (err) {
        console.error("Upload failed:", err);
        }
    };

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
      { label: "Popular", path: "/mainsocial/videos/popular" },
      { label: "Following", path: "/mainsocial/videos/following" },
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
    return (
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/popularVideos')}
                      >
                        Popular
                      </Button>
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/followingVideos')}
                      >
                        Following
                      </Button>
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                      >
                        Post Video
                      </Button>*/}
        {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}

                  <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Video
                    </Button>
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>

        {/*<Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Upload a Video</DialogTitle>
          <DialogContent>
            <input
              type="file"
              accept="video/*"
              onChange={(e) => setVideoFile(e.target.files[0])}
              style={{ marginTop: 16 }}
            />
            <Button
                variant="outlined"
                component="label"
                sx={{ mt: 2 }}
            >
                Upload Thumbnail (optional)
            <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => setThumbnailFile(e.target.files[0])}
            />
            </Button>

            {thumbnailFile && (
            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                Selected: {thumbnailFile}
            </Typography>
            )}
            <TextField
              label="Title"
              fullWidth
              multiline
              rows={3}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{ mt: 2 }}
            />
            <TextField
              label="Description"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{ mt: 2 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleUpload} variant="contained">Upload</Button>
          </DialogActions>
        </Dialog> */}
        {/*<Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Upload a Video</DialogTitle>
        <DialogContent
            dividers
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
            >
            <input
                type="file"
                accept="video/*"
                onChange={(e) => setVideoFile(e.target.files[0])}
            />

            <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{
                height: 48,
                borderColor: "grey.400",
                justifyContent: "flex-start",
                }}
            >
                Upload Thumbnail (optional)
                <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => setThumbnailFile(e.target.files[0])}
                />
            </Button>

            {thumbnailFile && (
                <Typography variant="caption" color="text.secondary">
                Selected: {thumbnailFile.name}
                </Typography>
            )}

            <TextField
                label="Title"
                fullWidth
                multiline
                rows={2}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />

            <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            />
            </DialogContent>

            <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleUpload} variant="contained">Upload</Button>
          </DialogActions>
        </Dialog>*/}

        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
            <DialogTitle sx={{ fontWeight: "bold" }}>
                Upload a Video
            </DialogTitle>

            <DialogContent
                sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                pt: 1,
                }}
            >
                {/* Upload Video */}
                <Button variant="outlined" component="label">
                Upload Video
                <input
                    type="file"
                    accept="video/*"
                    hidden
                    onChange={(e) => {
                    const file = e.target.files[0];
                    setVideoFile(file);
                    setVideoFileName(file?.name || "");
                    }}
                />
                </Button>

                {videoFileName && (
                <Typography variant="caption" color="text.secondary">
                    Selected video: {videoFileName}
                </Typography>
                )}

                {/* Upload Thumbnail */}
                <Button variant="outlined" component="label">
                Upload Thumbnail (optional)
                <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => {
                    const file = e.target.files[0];
                    setThumbnailFile(file);
                    setThumbnailFileName(file?.name || "");
                    }}
                />
                </Button>

                {thumbnailFileName && (
                <Typography variant="caption" color="text.secondary">
                    Selected thumbnail: {thumbnailFileName}
                </Typography>
                )}

                {/*<TextField
                label="Title"
                fullWidth
                multiline
                rows={2}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                />*/}
                <TextField
                    label="Title"
                    fullWidth
                    multiline
                    rows={2}
                    value={title}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 100) {
                        setTitle(value);
                        }
                    }}
                    inputProps={{
                        maxLength: 100,
                    }}
                    helperText={`${title.length}/100 characters`}
                    FormHelperTextProps={{
                        sx: { textAlign: 'right' }
                    }}
                    error={title.length === 100} // Optional: turn red when at limit
                />

                <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button onClick={handleUpload} variant="contained">
                Post Video
                </Button>
            </DialogActions>
            </Dialog>

      {/*</Box>*/}
            {videos.map(video => (
               <Box 
                key={video._id} 
                //onClick={() => history.push(`/videos/${video._id}/comments`)}
                onClick={() => history.push(`/videos/${video._id}/comments`, { source: "popular" })}
                p={2}
                my={2}
                border="1px solid #ccc" 
                borderRadius="8px"
                sx={{ 
                    position: 'relative', 
                    maxWidth: 900, 
                    mx: "auto",
                    my: 2, 
                    cursor: "pointer",
                    "&:hover": {
                    backgroundColor: "#f9f9f9"
                    }
                    }}
                >
            {/*<Box position="absolute" top={8} right={8} zIndex={1}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => joinVideoCall(video._id)}
                            >
                                Join Video Call
                            </Button>
                        </Box>*/}
                        {/*
                        <Typography variant="subtitle1">
                            {video.title}
                        </Typography>
                        <Typography variant="subtitle1">
                            {video.author?.username || "Unknown"}
                        </Typography>
                        <video
                            controls
                            src={`http://localhost:3000${video.videoUrl}`}
                            style={{ width: '100%', maxHeight: 500 }}
                        />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            {video.description}
                        </Typography>
                        */}
                        <Box display="flex" alignItems="flex-start" gap={1}>
                            <Avatar
                                src={video.author?.profileImageUrl || '/default-avatar.jpg'}
                                alt={`${video.author?.first_name || ''} ${video.author?.last_name || ''}`}
                                onClick={(e) => visitProfile(e, video.author?._id)}
                                sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
                            />
                            <Box>
                            <Typography variant="subtitle1" fontWeight="bold"
                            onClick={(e) => visitProfile(e, video.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                {video.author?.first_name && video.author?.last_name
                                ? `${video.author.first_name} ${video.author.last_name}`
                                : 'Unknown Name'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary"
                            onClick={(e) => visitProfile(e, video.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                @{video.author?.username || 'unknown'}
                            </Typography>

                            </Box>
                            </Box>

                            <Typography variant="subtitle1">
                                {video.title}
                            </Typography>

                            {/*<CardMedia
                                component="video"
                                controls
                                src={`http://localhost:3000${video.videoUrl}`}
                                sx={{
                                    maxWidth: 900,       // large but still constrained
                                    width: '100%',
                                    display: 'block',
                                    margin: '16px auto 0 auto', // centers horizontally, adds top space
                                    borderRadius: 2,
                                    objectFit: 'contain'
                                }}
                            />*/}
                            {/*
                            {video.thumbnailUrl ? (
                                <CardMedia
                                    component="img"
                                    src={`http://localhost:3000${video.thumbnailUrl}`}
                                    sx={{
                                        maxWidth: 900,
                                        width: "100%",
                                        mt: 2,
                                        borderRadius: 2,
                                        cursor: "pointer",
                                    }}
                                />
                                ) : (
                                <CardMedia
                                    component="video"
                                    controls
                                    src={`http://localhost:3000${video.videoUrl}`}
                                    sx={{
                                        maxWidth: 900,
                                        width: "100%",
                                        mt: 2,
                                        borderRadius: 2,
                                    }}
                                />
                            )}*/}
                            <CardMedia
                                component="img"
                                src={video.thumbnailUrl}
                                sx={{
                                    maxWidth: 900,
                                    width: "100%",
                                    mt: 2,
                                    borderRadius: 2,
                                    cursor: "pointer",
                                }}
                            />
                            

                            {/*<Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                {video.description}
                            </Typography>*/}

                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                            >
                                {`${new Date(video.created_at).toLocaleString()}, ${
                                    video.commentCount
                                } ${video.commentCount === 1 ? "reply" : "replies"}`}
                            </Typography>

{/*}
                        <Box mt={1} px={2}>
                            <Button
                                size="small"
                                variant={video.voted ? "contained" : "outlined"}
                                onClick={() => toggleVote(video._id)}
                            >
                                {video.voted ? "Unvote" : "Upvote"}
                            </Button>
                            <Typography variant="body2" component="span" ml={2}>
                                {video.upvotes || 0} upvotes
                            </Typography>
                        </Box>

                        <Box mt={2} px={2}>
                            <TextField
                                placeholder="Add a comment"
                                value={video.newComment || ""}
                                onChange={(e) =>
                                setVideos(prev =>
                                    prev.map(p =>
                                    p._id === video._id ? { ...p, newComment: e.target.value } : p
                                    )
                                )
                                }
                                fullWidth
                                size="small"
                            />
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleAddComment(video._id, video.newComment)}
                                sx={{ mt: 1 }}
                            >
                                Submit Comment
                            </Button>
                            </Box>
                            */}
                            {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                                <Button
                                    size="small"
                                    variant={video.voted ? "contained" : "outlined"}
                                    //onClick={() => toggleVote(video._id)}
                                    onClick={(e) => {
                                        e.stopPropagation(); 
                                        toggleVote(video._id)
                                    }}
                                >
                                    ▲ {video.voted ? "Unvote" : "Upvote"}
                                </Button>
                                <Typography variant="body2">{video.upvotes} upvotes</Typography>
                                </Box>*/}
                                <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {video.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(video._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(video._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{video.upvotes} Power Votes</Typography>
                   </Box>

{/*}
                            <Box px={2} pb={2}>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ mt: 1 }}
                                onClick={() => history.push(`/videos/${video._id}/comments`)}
                            >
                                View Comments
                            </Button>
                        </Box>*/}
                            {/*<Button
                                variant="outlined"
                                size="small"
                                onClick={() => history.push(`/videos/${video._id}/comments`)}
                                sx={{ mt: 1 }}
                            >
                                View Comments
                            </Button>*/}
                        
                    </Box>
            ))}
            {videos.length === 0 && (
                <Typography variant="h6" align="center" color="text.secondary">
                    No videos from users you follow.
                </Typography>
            )}
        </div>
    );
}

export default VideosPopularPage;